<template>
 <div>
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="!cxt.isFilterMode()" style="overflow:hidden" justify-end>
          </v-layout>
          <v-layout v-show="cxt.isFilterMode()" justify-end>
            <v-flex sm6 xs8>
              <v-text-field
                autofocus
                label="Фильтр"
                v-show="cxt.isFilterMode()"
                v-model="cxt.filterString"
                v-on:input="onChangeFilter"
                solo flat
              ></v-text-field>
            </v-flex>
          </v-layout>
            <span v-show="!cxt.isSelectMode()">
              <span v-show="!cxt.isFilterMode()">
                <v-btn  icon @click="openDeed(null)">
                  <v-icon>add</v-icon>
                </v-btn>
              </span>
            </span>
          <v-ops-btn :cxt="cxt" flat></v-ops-btn>
      </v-toolbar>
    <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="getItemSet.isProcessing()" :indeterminate="true"></v-progress-linear>
    <v-card-scroll ref="cardScroll" v-on:nextPage="nextPage">
      <v-list
      three-line dense>
        <template v-for="item in this.filteredItems">
          <v-list-tile v-bind:key="item.id" @click.stop="!cxt.isSelectMode() ? openItem(item) : cxt.select(item.id)"
          :value="cxt.activated(item.id)"
          active-class="v-dealger-favorite-active v-list__tile--highlighted "
          >
            <v-list-tile-content style="justify-content: start">
              <!-- <span style="white-space: normal;"><b>{{item.name}}</b></span> -->
              <v-list-tile-title><b><a :href="getItemRef(item)">{{item.title}}</a></b></v-list-tile-title>
              <v-list-tile-sub-title>
                {{item.description}}
                 <!-- <span style="white-space: normal;">{{item.description}}</span> -->
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text v-show="!cxt.isSelectMode()"> {{formatState(item.state)}} </v-list-tile-action-text>
              <span v-show="cxt.isSelectMode()">
                <v-list-tile-action-text>  {{formatState(item.state)}} </v-list-tile-action-text>
                <v-icon v-show="cxt.check(item.id)">check_box</v-icon>
                <v-icon v-show="cxt.uncheck(item.id)">check_box_outline_blank</v-icon>
              </span>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
      <v-panel-title @click="nextPage()" :value="false" :caption="'Еще'" :expandable="filteredItems.length < getItemSet.getTotal()">
      </v-panel-title>
    </v-card-scroll>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import dialogs from '../common/dialogs'
  import vOpsBtn from '../common/OpsBtn'
  import vCardScroll from '../common/CardScroll'
  import vPanelTitle from '../info/PanelTitle'

  // import vContactNew from './ContactNew.vue'
  import people from './index.js'

  class RemoveAssistAction extends classes.Action {
    constructor (context) {
      super(context,
        'Удалить записи о людях',
        null,
        () => {
          this.context.deleteIndividuals(this.context.cxt.selectedIds)
        }
        )
    }
  }

  export default {
    name: 'people-set',
    components: {vOpsBtn, vPanelTitle, vCardScroll},
    data: () => ({
      cxt: null
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => item.id + '')
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      // cxt.actions.push(new classes.ActiveScopeAction(cxt))
      cxt.actions.push(new classes.AllScopeAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.Action(this, 'Новый контакт', null,
        () => this.newContact()))
      cxt.actions.push(new classes.Action(this, 'Импорт из файла', null,
        () => this.loadContact()))

      cxt.selectActions.push(new classes.FilterAction(cxt))
      cxt.selectActions.push(new classes.FilterEndAction(cxt))
      cxt.selectActions.push(new RemoveAssistAction(this))

      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectAllAction(cxt))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      cxt.title = 'Физические лица'
      cxt.titleIcon = 'people_outline'
      cxt.selectTitle = 'Выбор контакта'
      cxt.filterMode = true

      this.cxt = cxt
    },
    mounted () {
      this.cxt.filterString = this.getItemSet.getFilter().search
      this.setActivated()
      this.fetchData()
    },
    props: {
      itemId: {
        type: String,
        default: null
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.setActivated()
        this.fetchData()
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.setActivated()
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getRefToUrl: 'getRefToUrl',
        getProfileHaveClient: 'getProfileHaveClient',
        getItemSet: 'getPeopleSet'
      }),
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items.sort((a, b) => formats.compareString(a.title, b.title))
      },
      filteredItems () {
        return this.orderedItems
      },
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setPeopleFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchPeople', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      nextPage () {
        this.$store.commit('nextPeople')
        this.$store.dispatch('fetchPeople')
      },
      fetchData () {
        if (this.getProfileHaveClient) {
          this.changeFilterContext({search: this.cxt.filterString})
        }
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      setActivated () {
        console.log('setActivated 0')
        if (this.$router && this.$router.options && this.$router.options.from) {
          let from = this.$router.options.from
          if (from.params && from.params.personId) {
            let itemId = from.params.personId
            let item = this.items.find(i => '' + i.id === itemId)
            if (item) {
              console.log('setActivated', item.id)
              this.cxt.activate(item.id)
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
        }
      },
      formatState (state) {
        return state
      },
      openItem (item) {
        people.open(item.id)
      },
      getItemRef (item) {
        return people.getItemRef(item.id)
      },
      newContact () {
        people.newForm().then(() => {
          this.fetchData()
        })
      },
      loadContact () {
        people.loadForm().then(() => {
          this.fetchData()
        })
      },
      deleteIndividuals (selectedIds) {
        if (Array.isArray(selectedIds)) {
          dialogs.confirm(this,
          'Подтвердите',
          `Удалить ${selectedIds.length} записей о людях?`,
          (self) => {
            self.$store.dispatch('deletePeopleIndividuals', {ids: selectedIds})
            self.cxt.toViewMode()
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PeopleSet.vue?48d4656b